import { render, staticRenderFns } from "./PayrollActions.vue?vue&type=template&id=1afaf47c&scoped=true&"
import script from "./PayrollActions.vue?vue&type=script&lang=js&"
export * from "./PayrollActions.vue?vue&type=script&lang=js&"
import style0 from "./PayrollActions.vue?vue&type=style&index=0&id=1afaf47c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afaf47c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1afaf47c')) {
      api.createRecord('1afaf47c', component.options)
    } else {
      api.reload('1afaf47c', component.options)
    }
    module.hot.accept("./PayrollActions.vue?vue&type=template&id=1afaf47c&scoped=true&", function () {
      api.rerender('1afaf47c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Invoices/History/PayrollActions.vue"
export default component.exports